export default __webpack_public_path__ + "static/media/wwr-subImg1.0eab074e.webp";